import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';

@Injectable({ providedIn: 'any' })
export class AuthEffects {
    constructor(
        private actions$: Actions,
        private store$: Store,
    ) {}
}
